import * as types from './mutationsType'

const mutations = {
  [types.SET_RANK] (state, rank) {
    state.rank.monthRank = rank.monthRank;
    state.rank.totalRank = rank.totalRank;
    state.rank.weekRank = rank._id;
  },
  [types.SET_SEARCH] (state, search) {
    state.search = search
  },
  [types.SET_BOOK] (state, book) {
    state.book.id = book._id;
    state.book.title = book.title;
    state.book.cover = book.cover
  },
  saveNavIndex: function (state, roslov) {
  	console.log('1111', roslov)
    state.navInde = roslov
  },
  saveSwiperIndex: function (state, res) {
  	console.log('2222222', res)
    state.swpierIndex = res
  },
  // 一级 -- 二级
  saveSecondCategroy: function (state, roslov) {
  	  // debugger
  	console.log('1111', roslov)
    state.secondCategroy = roslov
  },
  saveSwipersecondCategroy: function (state, roslov) {
  	console.log('1111', roslov)
    state.swipersecondCategroy = roslov
  },
  saveSecondCategroy02: function (state, roslov) {
  	console.log('1111', roslov)
    state.secondCategroy02 = roslov
  },
  saveSwipersecondCategroy02: function (state, roslov) {
  	console.log('1111', roslov)
    state.swipersecondCategroy02 = roslov
  },
  saveSecondCategroy03: function (state, roslov) {
  	console.log('1111', roslov)
    state.secondCategroy03 = roslov
  },
  saveSwipersecondCategroy03: function (state, roslov) {
  	console.log('1111', roslov)
    state.swipersecondCategroy03 = roslov
  },
  saveSecondCategroy04: function (state, roslov) {
  	console.log('1111', roslov)
    state.secondCategroy04 = roslov
  },
  saveSwipersecondCategroy04: function (state, roslov) {
  	console.log('1111', roslov)
    state.swipersecondCategroy04 = roslov
  },
  loginUserImgFn: function (state, roslov) {
    state.loginUserImg = roslov
  },
};
export default mutations
